export const routes = {
    index: '/',
    login: '/login',
    resetPassword: '/reset',
}
